import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-0"}],["path",{"d":"M9 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-1"}],["path",{"d":"M4 22l4 -2v-3h12","key":"svg-2"}],["path",{"d":"M11 20h9","key":"svg-3"}],["path",{"d":"M8 14l3 -2l1 -4c3 1 3 4 3 6","key":"svg-4"}]]

const IconMassage = createReactComponent('outline', 'massage', 'Massage', __iconNode);

export default IconMassage;